import React, { FC, PropsWithChildren } from 'react';
import PdfHtmlComp from 'react-pdf-html';

type Props = {
  level?: 1 | 2;
  fontSize?: string;
  textColor?: string;
  fontFamily?: string;
  fontWeight?: string;
  lineHeight?: number;
};
export const PdfHtml: FC<PropsWithChildren<Props>> = (props) => {
  const { level } = props;
  if (level && level === 2) {
    return (
      <PdfHtmlComp resetStyles={false}>
        {`<html> <body><style>
body, p{font-size: ${props.fontSize ?? '10px'};
      text-align: left;
      line-height: ${props.lineHeight ?? 1.5};
      margin: 0;
      font-family: ${props.fontFamily ?? 'Inter,sans-serif'};
      font-weight: ${props.fontWeight ?? 'normal'};
      color: ${props.textColor ?? '#5F5F5F'};}
      ul{margin: 0 20px 0 -20px;}
      ol{margin: 0 20px 0 -15px;}
</style>${props.children}</body></html>`}
      </PdfHtmlComp>
    );
  }
  return (
    <PdfHtmlComp resetStyles={false}>
      {`<html> <body><style>
body, p{font-size: ${props.fontSize ?? '13px'};
      text-align: left;
      line-height: ${props.lineHeight ?? 1.5};
      margin: 0;
      font-family: ${props.fontFamily ?? 'Inter,sans-serif'};
      font-weight: ${props.fontWeight ?? 'normal'};
      color: ${props.textColor ?? '#5F5F5F'};}
      ul{margin: 0 20px 0 -20px;}
      ol{margin: 0 20px 0 -15px;}
</style>${props.children}</body></html>`}
    </PdfHtmlComp>
  );
};
